import React from "react";

type VoterReachOutSectionHeaderProps = {
  title: string;
  description: string;
  icon: React.ElementType;
  action?: React.ReactNode;
  children?: React.ReactNode;
};

const VoterReachOutSectionHeader = ({
  title,
  description,
  icon: Icon,
  action,
  children,
}: VoterReachOutSectionHeaderProps) => (
  <section className="overflow-visible rounded-2xl border border-slate-200 bg-white shadow-sm">
    <div className="flex flex-col gap-4 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="min-w-0">
          <h1 className="text-xl font-medium tracking-tight text-slate-700">
            {title}
          </h1>
          <p className="mt-1 text-base leading-6 text-slate-400">
            {description}
          </p>
        </div>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
    {children && <div className="border-t border-slate-100">{children}</div>}
  </section>
);

export default VoterReachOutSectionHeader;
